// SPDX-License-Identifier: MIT
// Copyright (c) 2022 The Pybricks Authors

import { userProgramSize } from './UserProgramSize';

export default {
    userProgramSize,
};
